import { duration } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../Box/Box";
import { thumbSize } from "./ThumbStyle";
export const StepMarkContainer = styled(Box) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${thumbSize / 2}px;
  height: ${thumbSize + 4}px;
  opacity: 0;
  width: 100%;
  transition: ease-in-out ${duration.animation.moderate}ms;

  &.isDragging,
  &.isHover {
    opacity: 1;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RlcE1hcmtDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TbGlkZXIvc3R5bGVkL1N0ZXBNYXJrQ29udGFpbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUMxRSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEdBQUcsTUFBTSxlQUFlLENBQUM7QUFDaEMsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUV6QyxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7Ozs7ZUFJN0IsU0FBUyxHQUFHLENBQUM7WUFDaEIsU0FBUyxHQUFHLENBQUM7Ozs0QkFHRyxRQUFRLENBQUMsU0FBUyxDQUFDLFFBQVE7Ozs7OztDQU10RCxDQUFDIn0=